import { AxiosResponse } from "axios"
import { axiosInstanceWebsite } from "../instance"

export const getProductDetail = async (productId: string) => {
    const response: AxiosResponse = await axiosInstanceWebsite.get(
        `store/product/${productId}`,
        {
            headers: {
                "Content-Type": "application/json",
            },
        }
    )
    return response.data;
}